query findAuditLogEvent(
  $id: UUID!
) {
  event: eventByEventId(eventId: $id) {
    eventId
    eventName
    startsAt
    matchState
    sportId
    competitors
    isUsaView
    sport {
      sportLabel
    }
    markets: marketsByEventId(
      filter: {
        source: {
          in: ["INTERNAL_AGGREGATION"],
        },
      }
    ) {
      nodes {
        marketCode
        marketId
        marketType
        source
        inPlay
        marketSummary
        selections
      }
    }    
  }
}
